import { FaCheck, FaCodeBranch, FaForward, FaSpinner, FaTimes } from 'react-icons/fa';

type PageProcessingStatus = 'done' | 'error' | 'pending' | 'skip' | 'segmented' | undefined | 'processing';

export function DocumentPageStatusIcon({ status }: { status: PageProcessingStatus }) {
  if (status === 'done') {
    return <FaCheck className="text-green-500" />;
  }

  if (status === 'error') {
    return <FaTimes className="text-red-500" />;
  }

  if (status === 'skip') {
    return <FaForward className="text-gray-500" />;
  }

  // Terminal: page forked into child segment-pages; it does not continue downstream itself.
  if (status === 'segmented') {
    return <FaCodeBranch className="text-violet-500" title="Segmented into child pages" />;
  }

  return <FaSpinner className="text-gray-500 animate-spin" />;
}
